// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"598":"ed4849b64a7e47bd","1775":"107d3e3618bc16f3","3011":"9e9211da2bc24876","3069":"e09aad6b7e3c7d1b","4199":"6c7e1df0d252407d","4701":"7d53334cc039d710","6895":"aecda83a166885e5","8499":"ebd5f63accd03751"}[chunkId] + ".js";
};